'use client';
import { ComponentType } from 'react';
import { HeightSinceWidth } from '../placeholder/placeholder.component';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import { Props } from './code.component';
import dynamic from 'next/dynamic';

const DynamicCodeComponent: ComponentType<Props> = dynamic(() => import('./code.component'));

export default DynamicCodeComponent;

export function calculateCodeComponentPlaceholderConfig(): PlaceholderConfig {
  const heightSinceWidth: HeightSinceWidth = [
    { sinceWidth: 0, height: 150 },
    { sinceWidth: 425, height: 200 },
    { sinceWidth: 768, height: 270 },
    { sinceWidth: 1024, height: 325 },
    { sinceWidth: 1442, height: 437 }
  ];

  return {
    heightSinceWidth
  };
}
